import axios from "./index";
import { firestoreOperationsDb } from "../firebase";

export const fetchAuthCredentials = async (email, domain = "Nomadic care") => {
  const response = await axios.post("/loginWithGoogleAuth", { email, domain });
  return response;
};

export const getVerifyGoogleCredentials = async (otp, formattedKey) => {
  const response = await axios.post("/verifyGoogleAuthKey", {
    otp,
    formattedKey,
  });
  return response;
};

// Cache the key in memory so we only hit Firestore once per page load
let _cachedOtpApiKey = null;

const LOCAL_EMULATOR_OTP_API_KEY = "local-dev-otp-key";

async function getOtpApiKey() {
  if (_cachedOtpApiKey) return _cachedOtpApiKey;

  const configDoc = firestoreOperationsDb
    .collection("_config")
    .doc("otpSecurity");

  let snap = await configDoc.get();
  if (!snap.exists && process.env.REACT_APP_USE_EMULATORS === "true") {
    try {
      await configDoc.set(
        { apiKey: LOCAL_EMULATOR_OTP_API_KEY },
        { merge: true }
      );
      snap = await configDoc.get();
    } catch (e) {
      // Fall through to the normal "not found" error below.
    }
  }

  if (!snap.exists) throw new Error("OTP config not found in Firestore");
  const key = snap.data().apiKey;
  if (!key) throw new Error("apiKey missing in _config/otpSecurity");
  _cachedOtpApiKey = key;
  return key;
}

export const sendCarerSmsOtp = async (phoneNumber) => {
  const apiKey = await getOtpApiKey();
  const response = await axios.post(
    "/sendOtp",
    { phone: phoneNumber, source: "web" },
    { headers: { "x-api-key": apiKey } }
  );
  return response;
};

export const verifyCarerSmsOtp = async (phoneNumber, otp) => {
  const apiKey = await getOtpApiKey();
  const response = await axios.post(
    "/verifyOtp",
    { phone: phoneNumber, code: otp, source: "web" },
    { headers: { "x-api-key": apiKey } }
  );
  return response;
};

export const documentTitleFetch = async (url) => {
  const response = await axios.get(
    `https://australia-southeast1-nc-events-uat2.cloudfunctions.net//fetchTitleApi?url=${url}`
  );

  return response;
};
